import { render, staticRenderFns } from "./CartaoInformacoesComplexidade.vue?vue&type=template&id=f7bc601e&scoped=true"
import script from "./CartaoInformacoesComplexidade.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesComplexidade.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesComplexidade.vue?vue&type=style&index=0&id=f7bc601e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bc601e",
  null
  
)

export default component.exports